import { User } from 'types/user';

export const mockGetUserInfoResponse: User = {
  userId: 1,
  email: 'user@example.com',
  nickname: 'Axel',
  icon: 'https://disneyparkstory.com/wp-content/uploads/2017/09/apple-touch-icon.png',
  url: 'https://disneyparkstory.com',
  isSocialAccount: false,
};
